
import React from 'react'
import WorkProgressCard from './WorkProgressCard'
import { useNavigate } from 'react-router-dom'
import { Pie } from 'react-chartjs-2'
import { Pieoptions } from '../../../../../Helper/Data'
// import { useNavigate } from 'react-router-dom'


export default function WorkProgressCardManage(props) {

    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName } = props

    const navigate = useNavigate()
    const workProgressNavigate = (name, screenFlag) => {

        if (name === "Pending") {
            navigate(`/roadworkprogresspending?name=${name}&ApiFlag=Pending&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Completed") {
            navigate(`/roadworkprogresspending?name=${name}&ApiFlag=Completed&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        }
    }

    const Receiveddata = {
        labels: ["Pending", "Completed",],
        datasets: [
            {
                label: '# of Votes',
                data: [
                    Countdata && Countdata?.WorkProgress_PendingTotalCount,
                    Countdata && Countdata?.WorkProgress_CompletedTotalCount,
                    // 30,50
                ],
                backgroundColor: [
                    "#ffc33d",
                    "#f48242"
                ],
                borderColor: [
                    // '#28c8c1',
                    // '#172b4d',
                    // '#993366',
                    // '#593e89',
                    // '#94408e',
                    // '#c74382',
                    // '#fa5d00',
                    // '#529ad2',
                    // '#ffc137',
                ],
                borderWidth: 1,
            },
        ],
    };
    return (
        <div className='row'>
            <div className="col-12 col-lg-7">
                <div className="row pb-3 pb-lg-0 ps-lg-3" style={{ height: '100%' }}>
                    <div className="col-12">
                        <h5 className="ps-2 pt-2 pt-lg-1">Work Progress</h5>
                    </div>
                    <div className="col-lg-6 col-md-6" >
                        <WorkProgressCard
                            heading='Pending'
                            count={Countdata.WorkProgress_PendingTotalCount ? Countdata.WorkProgress_PendingTotalCount : '0'}
                            imgPath='./assets/img/expired.png'
                            cardName='wwork_img'
                            // navLink='/roadworkprogresspending'
                            countText='green_color'
                            workProgressNavigate={workProgressNavigate}
                        />
                    </div>

                    <div className="col-lg-6 col-md-6" >
                        <WorkProgressCard
                            heading='Completed'
                            count={Countdata.WorkProgress_CompletedTotalCount ? Countdata.WorkProgress_CompletedTotalCount : '0'}
                            imgPath='./assets/img/completed1.png'
                            cardName='wwork_img'
                            // navLink='/roadworkprogresscompleted'
                            countText='green_color'
                            workProgressNavigate={workProgressNavigate}
                        />
                    </div>
                </div>
            </div>
            <div className="col-12 col-lg-5 ">
                <div className="row ">
                    <div className="col-12 ">
                        <div className=" px-3 pb-2 upload_chart bg-white">
                            <div className="row d-flex justify-content-center align-items-center ">
                                {
                                    (Countdata?.WorkProgress_PendingTotalCount != 0) || (Countdata?.WorkProgress_CompletedTotalCount != 0) ?
                                        <Pie
                                            height={120}
                                            options={Pieoptions}
                                            data={Receiveddata}
                                        />
                                        :
                                        <div className='text-danger text-center pt-lg-5 fw-bolder'>
                                            No Data Found
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}






